export default __webpack_public_path__ + "163bf5f0f4a616150750411d63e8b8ef.svg";